var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43561 11.6631C8.54061 12.5253 9.92996 13.04 11.4387 13.04C15.0287 13.04 17.9587 10.11 17.9587 6.52C17.9587 2.93 15.0387 0 11.4387 0C7.83875 0 4.91875 2.93 4.91875 6.52C4.91875 8.06723 5.46112 9.49186 6.36656 10.6122L0.258745 16.72C-0.0312555 17.01 -0.0312555 17.49 0.258745 17.78C0.408745 17.93 0.598745 18 0.788745 18C0.978745 18 1.16874 17.93 1.31874 17.78L7.43561 11.6631ZM6.41875 6.52C6.41875 3.75 8.66875 1.5 11.4387 1.5C14.1987 1.5 16.4587 3.75 16.4587 6.52C16.4587 9.29 14.2087 11.54 11.4387 11.54C8.66875 11.54 6.41875 9.29 6.41875 6.52Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35875 7.27C7.94875 7.27 7.60875 6.93 7.60875 6.52C7.60875 4.41 9.32875 2.69 11.4387 2.69C11.8487 2.69 12.1887 3.03 12.1887 3.44C12.1887 3.85 11.8487 4.19 11.4387 4.19C10.1587 4.19 9.10875 5.23 9.10875 6.52C9.10875 6.93 8.76875 7.27 8.35875 7.27Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.4214b3833b955fcb976a8ed058c0106a.svg";
export { ForwardRef as ReactComponent };